module.exports = __webpack_public_path__ + "5286d488739c0cd2167585889417457f.svg";